import React from 'react';

import { useInternationalization } from '@progress/kendo-react-intl';

import { IWidgetCell } from '../../../../../types/IWidgetCell';

import './cashflowCell.scss';

const CashflowCell: React.FC<IWidgetCell> = ({
                                               dataItem,
                                               field,
                                               columnName,
                                               boardId,
                                               investorObjectId,
                                               treelist,
                                               handleCashflowOpen,
                                               selectedCurrency,
                                               singlePeriod,
                                               scale,
                                               style,
                                               className,
                                             }) => {
  const intl = useInternationalization();

  const item = dataItem[field];

  if (item === undefined) return <td />;

  const formatNumber = () => {
      if (typeof item === 'object' && item !== null) {
        return item.rowAmount === null ? '' : intl.toString(item.rowAmount, (item.isPercent ? 'p' : 'n') + scale || item.scale);
      } else {
        const index = field?.lastIndexOf('_');
        let objectField = field && field.substring(0, index);
        let objectItem = dataItem[objectField];

        return objectItem.rowAmount === null ? '' : intl.toString(objectItem.rowAmount, (objectItem.isPercent ? 'p' : 'n') + scale || objectItem.scale);
      }
  };


  return (
    <td style={style} className={className}>
      <div className='cashflow-cell'
           onClick={() => handleCashflowOpen(dataItem, field, columnName, boardId, investorObjectId, treelist, singlePeriod, selectedCurrency)}>
        {formatNumber()}
      </div>
    </td>
  );
};

export default CashflowCell;
